import "./methods-z8jwJOgY.js";
//#region src/protocol/cloud-plugin.ts
function isRecord$2(value) {
	return !!value && typeof value === "object" && !Array.isArray(value);
}
function normalizeCloudPluginAuth(value) {
	if (typeof value === "string" && value.trim()) return {
		type: "bearer",
		token: value.trim()
	};
}
function normalizeCloudPluginCredentials(value) {
	return typeof value === "string" ? value.trim() : "";
}
function normalizeCloudPluginSources(value) {
	if (!Array.isArray(value)) return [];
	const sources = [];
	for (const item of value) {
		if (typeof item === "string" && item.trim()) {
			sources.push({
				kind: "manifest",
				url: normalizeCloudPluginSourceUrl(item.trim(), "manifest")
			});
			continue;
		}
		if (!isRecord$2(item)) continue;
		const url = typeof item.url === "string" ? item.url.trim() : "";
		if (!url) continue;
		const kind = (typeof item.kind === "string" ? item.kind : "manifest") === "catalog" ? "catalog" : "manifest";
		const id = typeof item.id === "string" && item.id.trim() ? item.id.trim() : void 0;
		sources.push({
			id,
			kind,
			url: normalizeCloudPluginSourceUrl(url, kind)
		});
	}
	return sources;
}
function normalizeCloudSidecarSources(value) {
	if (!Array.isArray(value)) return [];
	const sources = [];
	for (const item of value) {
		if (typeof item === "string" && item.trim()) {
			sources.push({
				kind: "manifest",
				url: normalizeCloudSidecarSourceUrl(item.trim(), "manifest")
			});
			continue;
		}
		if (!isRecord$2(item)) continue;
		const url = typeof item.url === "string" ? item.url.trim() : "";
		if (!url) continue;
		const kind = (typeof item.kind === "string" ? item.kind : "manifest") === "catalog" ? "catalog" : "manifest";
		const id = typeof item.id === "string" && item.id.trim() ? item.id.trim() : void 0;
		sources.push({
			id,
			kind,
			url: normalizeCloudSidecarSourceUrl(url, kind)
		});
	}
	return sources;
}
function parseCloudPluginSourcesText(raw) {
	const text = raw?.trim();
	if (!text) return [];
	if (text.startsWith("[") || text.startsWith("{")) try {
		const parsed = JSON.parse(text);
		return normalizeCloudPluginSources(Array.isArray(parsed) ? parsed : [parsed]);
	} catch {
		return [];
	}
	return normalizeCloudPluginSources(text.split(/[\n,]/).map((part) => part.trim()).filter(Boolean));
}
function parseCloudSidecarSourcesText(raw) {
	const text = raw?.trim();
	if (!text) return [];
	if (text.startsWith("[") || text.startsWith("{")) try {
		const parsed = JSON.parse(text);
		return normalizeCloudSidecarSources(Array.isArray(parsed) ? parsed : [parsed]);
	} catch {
		return [];
	}
	return normalizeCloudSidecarSources(text.split(/[\n,]/).map((part) => part.trim()).filter(Boolean));
}
function normalizeCloudPluginSourceUrl(rawUrl, kind = "manifest") {
	if (kind !== "manifest") return rawUrl;
	try {
		const url = new URL(rawUrl);
		if (url.protocol !== "http:" && url.protocol !== "https:") return rawUrl;
		const pathname = url.pathname.replace(/\/+$/, "");
		if (!pathname || pathname === "/magic-md") {
			url.pathname = "/magic-md/plugin.json";
			url.search = "";
			url.hash = "";
			return url.toString();
		}
		return rawUrl;
	} catch {
		return rawUrl;
	}
}
function normalizeCloudSidecarSourceUrl(rawUrl, kind = "manifest") {
	if (kind !== "manifest") return rawUrl;
	try {
		const url = new URL(rawUrl);
		if (url.protocol !== "http:" && url.protocol !== "https:") return rawUrl;
		const pathname = url.pathname.replace(/\/+$/, "");
		if (!pathname || pathname === "/magic-md") {
			url.pathname = "/magic-md/sidecar.json";
			url.search = "";
			url.hash = "";
			return url.toString();
		}
		return rawUrl;
	} catch {
		return rawUrl;
	}
}
function isCloudPluginSourceDescriptor(value) {
	if (!isRecord$2(value)) return false;
	if (value.schemaVersion !== 1) return false;
	if (value.kind !== "cloud-worker" && value.kind !== "cloud-bundle") return false;
	if (!isRecord$2(value.plugin)) return false;
	if (typeof value.plugin.name !== "string" || !value.plugin.name) return false;
	if (typeof value.plugin.version !== "string" || !value.plugin.version) return false;
	if (typeof value.manifestUrl !== "string" || !value.manifestUrl) return false;
	return true;
}
function isCloudWorkerDescriptor(value) {
	if (!isCloudPluginSourceDescriptor(value) || value.kind !== "cloud-worker") return false;
	if (!isRecord$2(value.ui) || typeof value.ui.bundleUrl !== "string") return false;
	if (!isRecord$2(value.worker) || typeof value.worker.invokeUrl !== "string") return false;
	return true;
}
function isCloudBundleDescriptor(value) {
	if (!isCloudPluginSourceDescriptor(value) || value.kind !== "cloud-bundle") return false;
	if (!isRecord$2(value.bundle) || typeof value.bundle.baseUrl !== "string") return false;
	return isRecord$2(value.bundle.files) && Object.values(value.bundle.files).every((item) => typeof item === "string");
}
function createCloudPluginAuthHeaders(auth) {
	if (!auth) return {};
	return { Authorization: `Bearer ${auth.token}` };
}
function resolveCloudPluginAuthForUrl(credentials, _rawUrl, _id) {
	const token = credentials?.trim();
	return token ? {
		type: "bearer",
		token
	} : void 0;
}
//#endregion
//#region src/protocol/cloud-plugin-fetch.ts
function warn$2(warnings, onWarning, message) {
	warnings.push(message);
	onWarning?.(message);
}
async function fetchJson$2(url, fetchFn, headers) {
	const response = await fetchFn(url, { headers });
	if (!response.ok) throw new Error(`HTTP ${response.status} fetching ${url}`);
	return response.json();
}
function sourceFromCatalogItem$2(item) {
	if (isCloudPluginSourceDescriptor(item)) return [];
	if (typeof item === "object" && item && "source" in item) {
		const source = item.source;
		return typeof source === "string" && source.trim() ? [{
			kind: "manifest",
			url: source.trim()
		}] : [];
	}
	return normalizeCloudPluginSources([item]);
}
async function fetchCloudPluginDescriptors(sources, options = {}) {
	const fetchFn = options.fetchFn ?? globalThis.fetch?.bind(globalThis);
	if (!fetchFn) throw new Error("fetch is not available in this runtime");
	const warnings = [];
	const descriptors = [];
	const seen = /* @__PURE__ */ new Set();
	const queue = [...sources];
	while (queue.length > 0) {
		const source = queue.shift();
		if (!source) continue;
		if (seen.has(source.url)) continue;
		seen.add(source.url);
		try {
			const headers = options.headersForSource?.(source.url, source) ?? createCloudPluginAuthHeaders(void 0);
			const json = await fetchJson$2(source.url, fetchFn, headers);
			if (source.kind === "catalog") {
				const catalog = json;
				if (!Array.isArray(catalog.plugins)) {
					warn$2(warnings, options.onWarning, `Cloud plugin catalog ${source.url} does not contain a plugins array`);
					continue;
				}
				for (const item of catalog.plugins) if (isCloudPluginSourceDescriptor(item)) descriptors.push(item);
				else queue.push(...sourceFromCatalogItem$2(item));
				continue;
			}
			if (!isCloudPluginSourceDescriptor(json)) {
				warn$2(warnings, options.onWarning, `Cloud plugin manifest ${source.url} is not a valid source descriptor`);
				continue;
			}
			descriptors.push(json);
		} catch (error) {
			warn$2(warnings, options.onWarning, `Failed to fetch cloud plugin source ${source.url}: ${error instanceof Error ? error.message : String(error)}`);
		}
	}
	return {
		descriptors,
		warnings
	};
}
//#endregion
//#region src/protocol/cloud-sidecar-fetch.ts
function isRecord$1(value) {
	return typeof value === "object" && value !== null && !Array.isArray(value);
}
function isSidecarManifest(value) {
	return isRecord$1(value) && typeof value.id === "string" && typeof value.name === "string" && typeof value.version === "string" && Array.isArray(value.capabilities);
}
function warn$1(warnings, onWarning, message) {
	warnings.push(message);
	onWarning?.(message);
}
async function fetchJson$1(url, fetchFn, headers) {
	const response = await fetchFn(url, { headers });
	if (!response.ok) throw new Error(`HTTP ${response.status} fetching ${url}`);
	return response.json();
}
function deriveEndpointFromManifestUrl(url) {
	try {
		const parsed = new URL(url);
		const pathname = parsed.pathname.replace(/\/+$/, "");
		if (!pathname || pathname === "/magic-md" || pathname === "/magic-md/sidecar.json") {
			parsed.pathname = "/magic-md/sidecar/rpc";
			parsed.search = "";
			parsed.hash = "";
			return parsed.toString();
		}
	} catch {
		return;
	}
}
function normalizeCloudManifest(manifest, source) {
	const rawTransport = isRecord$1(manifest.transport) ? manifest.transport : {};
	const transport = {
		...rawTransport,
		type: "cloud-worker-http",
		manifestUrl: typeof rawTransport.manifestUrl === "string" ? rawTransport.manifestUrl : source.url,
		endpoint: typeof rawTransport.endpoint === "string" && rawTransport.endpoint.trim() ? rawTransport.endpoint : deriveEndpointFromManifestUrl(source.url),
		sourceId: source.id,
		sourceUrl: source.url
	};
	return {
		...manifest,
		sourceKind: "cloud",
		runtime: typeof manifest.runtime === "string" ? manifest.runtime : "cloud-worker",
		protocol: typeof manifest.protocol === "string" ? manifest.protocol : "jsonrpc-http",
		transport
	};
}
function sourceFromCatalogItem$1(item) {
	if (isSidecarManifest(item)) return [];
	if (isRecord$1(item) && "source" in item) {
		const source = item.source;
		return typeof source === "string" && source.trim() ? [{
			kind: "manifest",
			url: source.trim()
		}] : [];
	}
	return normalizeCloudSidecarSources([item]);
}
async function fetchCloudSidecarManifests(sources, options = {}) {
	const fetchFn = options.fetchFn ?? globalThis.fetch?.bind(globalThis);
	if (!fetchFn) throw new Error("fetch is not available in this runtime");
	const warnings = [];
	const manifests = [];
	const seen = /* @__PURE__ */ new Set();
	const queue = [...sources];
	while (queue.length > 0) {
		const source = queue.shift();
		if (!source) continue;
		if (seen.has(source.url)) continue;
		seen.add(source.url);
		try {
			const headers = options.headersForSource?.(source.url, source) ?? createCloudPluginAuthHeaders(resolveCloudPluginAuthForUrl(options.credentials, source.url, source.id));
			const json = await fetchJson$1(source.url, fetchFn, headers);
			if (source.kind === "catalog") {
				const catalog = json;
				if (!Array.isArray(catalog.sidecars)) {
					warn$1(warnings, options.onWarning, `Cloud sidecar catalog ${source.url} does not contain a sidecars array`);
					continue;
				}
				for (const item of catalog.sidecars) if (isSidecarManifest(item)) manifests.push(normalizeCloudManifest(item, source));
				else queue.push(...sourceFromCatalogItem$1(item));
				continue;
			}
			if (!isSidecarManifest(json)) {
				warn$1(warnings, options.onWarning, `Cloud sidecar manifest ${source.url} is not a valid sidecar manifest`);
				continue;
			}
			manifests.push(normalizeCloudManifest(json, source));
		} catch (error) {
			warn$1(warnings, options.onWarning, `Failed to fetch cloud sidecar source ${source.url}: ${error instanceof Error ? error.message : String(error)}`);
		}
	}
	return {
		manifests,
		warnings
	};
}
//#endregion
//#region src/protocol/cloud-extension.ts
function isRecord(value) {
	return !!value && typeof value === "object" && !Array.isArray(value);
}
function normalizeCloudExtensionCredentials(value) {
	return normalizeCloudPluginCredentials(value);
}
function normalizeCloudExtensionSourceUrl(rawUrl, kind = "manifest") {
	if (kind !== "manifest") return rawUrl;
	try {
		const url = new URL(rawUrl);
		if (url.protocol !== "http:" && url.protocol !== "https:") return rawUrl;
		const pathname = url.pathname.replace(/\/+$/, "");
		if (!pathname || pathname === "/magic-md") {
			url.pathname = "/magic-md/extension.json";
			url.search = "";
			url.hash = "";
			return url.toString();
		}
		return rawUrl;
	} catch {
		return rawUrl;
	}
}
function normalizeCloudExtensionSources(value) {
	if (!Array.isArray(value)) return [];
	const sources = [];
	for (const item of value) {
		if (typeof item === "string" && item.trim()) {
			sources.push({
				kind: "manifest",
				url: normalizeCloudExtensionSourceUrl(item.trim(), "manifest")
			});
			continue;
		}
		if (!isRecord(item)) continue;
		const url = typeof item.url === "string" ? item.url.trim() : "";
		if (!url) continue;
		const kind = (typeof item.kind === "string" ? item.kind : "manifest") === "catalog" ? "catalog" : "manifest";
		const id = typeof item.id === "string" && item.id.trim() ? item.id.trim() : void 0;
		sources.push({
			id,
			kind,
			url: normalizeCloudExtensionSourceUrl(url, kind)
		});
	}
	return sources;
}
function parseCloudExtensionSourcesText(raw) {
	const text = raw?.trim();
	if (!text) return [];
	if (text.startsWith("[") || text.startsWith("{")) try {
		const parsed = JSON.parse(text);
		return normalizeCloudExtensionSources(Array.isArray(parsed) ? parsed : [parsed]);
	} catch {
		return [];
	}
	return normalizeCloudExtensionSources(text.split(/[\n,]/).map((part) => part.trim()).filter(Boolean));
}
function createCloudExtensionAuthHeaders(credentials, url, extensionId) {
	return createCloudPluginAuthHeaders(resolveCloudPluginAuthForUrl(credentials, url, extensionId));
}
function isCloudExtensionSourceDescriptor(value) {
	if (!isRecord(value)) return false;
	if (value.schemaVersion !== 1) return false;
	if (value.kind !== "cloud-worker") return false;
	if (!isRecord(value.extension)) return false;
	if (typeof value.extension.id !== "string" || !value.extension.id) return false;
	if (typeof value.extension.version !== "string" || !value.extension.version) return false;
	return typeof value.manifestUrl === "string" && !!value.manifestUrl;
}
function isCloudWorkerExtensionDescriptor(value) {
	if (!isCloudExtensionSourceDescriptor(value)) return false;
	if (!isRecord(value.ui) || typeof value.ui.bundleUrl !== "string") return false;
	return isRecord(value.worker) && typeof value.worker.invokeUrl === "string";
}
//#endregion
//#region src/protocol/cloud-extension-fetch.ts
function warn(warnings, onWarning, message) {
	warnings.push(message);
	onWarning?.(message);
}
async function fetchJson(url, fetchFn, headers) {
	const response = await fetchFn(url, { headers });
	if (!response.ok) throw new Error(`HTTP ${response.status} fetching ${url}`);
	return response.json();
}
function sourceFromCatalogItem(item) {
	if (isCloudExtensionSourceDescriptor(item)) return [];
	if (typeof item === "object" && item && "source" in item) {
		const source = item.source;
		return typeof source === "string" && source.trim() ? [{
			kind: "manifest",
			url: source.trim()
		}] : [];
	}
	return normalizeCloudExtensionSources([item]);
}
async function fetchCloudExtensionDescriptors(sources, options = {}) {
	const fetchFn = options.fetchFn ?? globalThis.fetch?.bind(globalThis);
	if (!fetchFn) throw new Error("fetch is not available in this runtime");
	const warnings = [];
	const descriptors = [];
	const seen = /* @__PURE__ */ new Set();
	const queue = [...sources];
	while (queue.length > 0) {
		const source = queue.shift();
		if (!source) continue;
		if (seen.has(source.url)) continue;
		seen.add(source.url);
		try {
			const headers = options.headersForSource?.(source.url, source) ?? createCloudExtensionAuthHeaders(options.credentials, source.url, source.id);
			const json = await fetchJson(source.url, fetchFn, headers);
			if (source.kind === "catalog") {
				const catalog = json;
				if (!Array.isArray(catalog.extensions)) {
					warn(warnings, options.onWarning, `Cloud extension catalog ${source.url} does not contain an extensions array`);
					continue;
				}
				for (const item of catalog.extensions) if (isCloudExtensionSourceDescriptor(item)) descriptors.push(item);
				else queue.push(...sourceFromCatalogItem(item));
				continue;
			}
			if (!isCloudExtensionSourceDescriptor(json)) {
				warn(warnings, options.onWarning, `Cloud extension manifest ${source.url} is not a valid source descriptor`);
				continue;
			}
			descriptors.push(json);
		} catch (error) {
			warn(warnings, options.onWarning, `Failed to fetch cloud extension source ${source.url}: ${error instanceof Error ? error.message : String(error)}`);
		}
	}
	return {
		descriptors,
		warnings
	};
}
//#endregion
//#region src/protocol/initialize.ts
/** Engine RPC compatibility version, independent from product/package versions. */
const ENGINE_PROTOCOL_VERSION = "1";
//#endregion
//#region src/protocol/jsonrpc.ts
const ErrorCodes = {
	ParseError: -32700,
	InvalidRequest: -32600,
	MethodNotFound: -32601,
	InvalidParams: -32602,
	InternalError: -32603,
	SessionNotFound: -32001,
	DefinitionNotFound: -32002,
	PluginNotFound: -32003,
	ExecutionCancelled: -32004,
	SidecarError: -32005,
	SessionRevisionConflict: -32006
};
//#endregion
//#region src/protocol/sidecar.ts
const SIDECAR_STATIC_REF_RE = /^%([^%\s]+)%$/;
function resolveSidecarText(value, i18n, options = {}) {
	const match = SIDECAR_STATIC_REF_RE.exec(value.trim());
	if (!match || !i18n) return value;
	const key = match[1];
	const locale = options.locale ?? "zh-CN";
	const fallbackLocale = options.fallbackLocale ?? "zh-CN";
	return i18n.bundles[locale]?.[i18n.namespace]?.[key] ?? i18n.bundles[fallbackLocale]?.[i18n.namespace]?.[key] ?? i18n.bundles["en-US"]?.[i18n.namespace]?.[key] ?? value;
}
function resolveSidecarManifest(manifest, i18n = manifest.i18n, options = {}) {
	return resolveSidecarValue(manifest, i18n, options);
}
function resolveSidecarValue(value, i18n, options) {
	if (typeof value === "string") return resolveSidecarText(value, i18n, options);
	if (Array.isArray(value)) return value.map((item) => resolveSidecarValue(item, i18n, options));
	if (!value || typeof value !== "object") return value;
	return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, key === "i18n" ? item : resolveSidecarValue(item, i18n, options)]));
}
//#endregion
export { normalizeCloudSidecarSourceUrl as C, resolveCloudPluginAuthForUrl as D, parseCloudSidecarSourcesText as E, normalizeCloudPluginSources as S, parseCloudPluginSourcesText as T, isCloudPluginSourceDescriptor as _, fetchCloudExtensionDescriptors as a, normalizeCloudPluginCredentials as b, isCloudWorkerExtensionDescriptor as c, normalizeCloudExtensionSources as d, parseCloudExtensionSourcesText as f, isCloudBundleDescriptor as g, createCloudPluginAuthHeaders as h, ENGINE_PROTOCOL_VERSION as i, normalizeCloudExtensionCredentials as l, fetchCloudPluginDescriptors as m, resolveSidecarText as n, createCloudExtensionAuthHeaders as o, fetchCloudSidecarManifests as p, ErrorCodes as r, isCloudExtensionSourceDescriptor as s, resolveSidecarManifest as t, normalizeCloudExtensionSourceUrl as u, isCloudWorkerDescriptor as v, normalizeCloudSidecarSources as w, normalizeCloudPluginSourceUrl as x, normalizeCloudPluginAuth as y };
